"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStylesUtils = void 0;
var _react = require("react");
var _CetComponentsProvider = require("../providers/CetComponentsProvider");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var BASE_FONT_SIZE = 10;
var useStylesUtils = function useStylesUtils(contextValues) {
  var _contextValues$rootFo;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    _useContext$rootFontS = _useContext.rootFontSize,
    rootFontSize = _useContext$rootFontS === void 0 ? 10 : _useContext$rootFontS,
    _useContext$direction = _useContext.direction,
    direction = _useContext$direction === void 0 ? 'rtl' : _useContext$direction;
  //on first load this hooks is being called before context is initialized
  rootFontSize = (_contextValues$rootFo = contextValues === null || contextValues === void 0 ? void 0 : contextValues.rootFontSize) !== null && _contextValues$rootFo !== void 0 ? _contextValues$rootFo : rootFontSize;
  direction = contextValues !== null && contextValues !== void 0 && contextValues.language ? _CetComponentsProvider.rtlLanguages.includes(contextValues.language) ? 'rtl' : 'ltr' : direction;
  var pxToRem = (0, _react.useCallback)(function (px) {
    var baseProportion = rootFontSize / BASE_FONT_SIZE;
    var rem = px / BASE_FONT_SIZE;
    return rem / baseProportion + 'rem';
  }, [rootFontSize]);
  var setStartDirection = function setStartDirection(px) {
    var left;
    var right;
    if (direction === 'rtl') {
      left = 'auto';
      right = pxToRem(px);
    } else {
      right = 'auto';
      left = pxToRem(px);
    }
    return {
      left: left,
      right: right
    };
  };
  var setEndDirection = function setEndDirection(px) {
    var left;
    var right;
    if (direction === 'rtl') {
      right = 'auto';
      left = pxToRem(px);
    } else {
      left = 'auto';
      right = pxToRem(px);
    }
    return {
      left: left,
      right: right
    };
  };
  var getMeasurement = (0, _react.useCallback)(function (measurement) {
    return isNaN(Number(measurement)) ? measurement : pxToRem(Number(measurement));
  }, [pxToRem]);
  var scrollProps = function scrollProps(slideBy) {
    var px = slideBy === 'scroll' ? 0 : 7;
    return {
      '&::-webkit-scrollbar': {
        width: pxToRem(px),
        height: pxToRem(px)
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: pxToRem(10),
        backgroundColor: '#ececf0'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#7f7f90',
        outline: '1px solid #ececf0',
        borderRadius: pxToRem(10)
      }
    };
  };
  var maskProps = function maskProps(isOpen) {
    return {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      pointerEvents: 'all',
      background: 'rgba(0, 0, 0, 0.6)',
      transition: 'opacity 0.3s ease-in-out',
      opacity: isOpen ? 1 : 0,
      zIndex: 9999
    };
  };
  var fontSizeProps = function fontSizeProps(size) {
    var fontSize;
    switch (size) {
      case 'x-small':
        fontSize = pxToRem(13);
        break;
      case 'small':
        fontSize = pxToRem(14);
        break;
      case 'medium':
        fontSize = pxToRem(16);
        break;
      case 'large':
        fontSize = pxToRem(18);
        break;
      case 'x-large':
        fontSize = pxToRem(24);
        break;
      case 'stretch':
        fontSize = 'initial';
    }
    return {
      fontSize: fontSize
    };
  };
  var borderRadiusProps = function borderRadiusProps(borderRadius) {
    var borderRadiusObj = {}; //todo: fix type
    if (borderRadius) {
      for (var _i = 0, _Object$entries = Object.entries(borderRadius); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        borderRadiusObj[key] = getMeasurement(value);
      }
      return borderRadiusObj;
    }
    return {};
  };
  var getElementHeight = function getElementHeight(size) {
    switch (size) {
      case 'x-small':
        return pxToRem(20);
      case 'small':
        return pxToRem(28);
      case 'medium':
        return pxToRem(36);
      case 'large':
        return pxToRem(40);
      case 'x-large':
        return pxToRem(48);
      case 'stretch':
        return '100%';
    }
  };
  return {
    pxToRem: pxToRem,
    setStartDirection: setStartDirection,
    setEndDirection: setEndDirection,
    getMeasurement: getMeasurement,
    scrollProps: scrollProps,
    maskProps: maskProps,
    borderRadiusProps: borderRadiusProps,
    fontSizeProps: fontSizeProps,
    getElementHeight: getElementHeight
  };
};
exports.useStylesUtils = useStylesUtils;